module.exports = __WEBPACK_EXTERNAL_MODULE_babylonjs_Materials_effect__;